<div class="message-container" *ngIf="(messages$ | async)?.length">
  <div *ngFor="let message of messages$ | async">
    <app-message [message]="message"></app-message>
  </div>
</div>
